import React, { useEffect, useState } from 'react'

//MUI
import { Alert, AlertTitle, AppBar, Box, Button, Card, CardContent, CardHeader, Container, Grid, IconButton, Menu, MenuItem, Toolbar, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';

//react-beatufil-dnd
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

//Router dom
import { Link } from 'react-router-dom';
import AddOldWebinar from './AddOldWebinar';

const OldWebinars = () => {
    const [data, setData] = useState([])
    const [selectedIndex, setSelectedIndex] = useState(null)
    const [openDialog, setOpenDialog] = useState(false)


    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event, index) => {
        setAnchorEl(event.currentTarget);
        setSelectedIndex(index)
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpenDialog = () => {
        setOpenDialog(true)
    }

    //drag
    const handleDrag = (result) => {
        if (!result.destination) return;

        const arr = [...data];

        //Changing the position of Array element
        let removedItem = arr.splice(result.source.index, 1)[0];
        arr.splice(result.destination.index, 0, removedItem);

        //Updating the list
        setData(arr);
    };

    const handleDelete = (index) => {
        const confirmed = window.confirm('¿Estás seguro de que deseas eliminar este Oldwebinar?');
        if (!confirmed) return;

        const updatedForms = [...data];
        updatedForms.splice(index, 1);
        setData(updatedForms);
        localStorage.setItem('oldWebinars', JSON.stringify(updatedForms));
    };

    useEffect(() => {
        const savedForms = JSON.parse(localStorage.getItem('oldWebinars')) || [];
        setData(savedForms)
    }, []);

    const formatFecha = (dateString) => {
        const meses = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];

        const date = new Date(dateString);
        const day = date.getDate();
        const month = meses[date.getMonth()];
        const year = date.getFullYear();

        return `${day} de ${month} del ${year}`;
    };

    return (
        <>
            <Container maxWidth='xl' sx={{ mb: 5 }}>
                <Box display='flex' justifyContent='space-between' gap={2} flexWrap='wrap' mb={5}>
                    <Typography variant='h5' sx={{ fontWeight: '600', fontSize: '28px', color: '#004A86', my: 'auto' }}>Webinars anteriores</Typography>
                    <Button onClick={handleOpenDialog} size='large' variant='contained' sx={{ textTransform: 'none', my: 'auto' }} endIcon={<AddIcon />}>
                        Añadir nuevo
                    </Button>
                </Box>
                {
                    data.length > 0
                        ?
                        <DragDropContext onDragEnd={handleDrag}>
                            <Droppable droppableId="webinars">
                                {(provided) => (
                                    <Grid container spacing={5} {...provided.droppableProps} ref={provided.innerRef}>
                                        {
                                            data.map((item, index) => (
                                                <Draggable
                                                    key={item.title}
                                                    draggableId={`${item.id}`}
                                                    index={index}
                                                >
                                                    {(provided) => (
                                                        <Grid item xxl={6} xl={6} lg={6} md={10} sm={12} xs={12}
                                                            sx={{ display: 'flex', mx: { xxl: '0', xl: '0', lg: '0', md: 'auto', sm: 'auto', xs: 'auto' } }}
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <Card sx={{ width: '100%', boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px' }}>
                                                                <CardHeader
                                                                    action={
                                                                        <IconButton onClick={(e) => handleClick(e, index)}>
                                                                            <MoreVertIcon />
                                                                        </IconButton>
                                                                    }
                                                                    title={
                                                                        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
                                                                            {item.title}
                                                                        </Typography>
                                                                    }
                                                                    subheader={formatFecha(item.date)}
                                                                    subheaderTypographyProps={{ variant: 'body2' }}
                                                                />
                                                                <CardContent>
                                                                    <Box sx={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '8px' }}>
                                                                        <iframe
                                                                            src={item.iframe}
                                                                            frameBorder="0"
                                                                            allowFullScreen
                                                                            title="OldWebinar"
                                                                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                                        >
                                                                        </iframe>
                                                                    </Box>
                                                                </CardContent>
                                                            </Card>
                                                            <Menu
                                                                anchorEl={anchorEl}
                                                                open={open}
                                                                onClose={handleClose}
                                                            >
                                                                <MenuItem>Editar</MenuItem>
                                                                <MenuItem
                                                                    onClick={() => {
                                                                        handleDelete(selectedIndex)
                                                                        handleClose()
                                                                    }}
                                                                >
                                                                    Eliminar
                                                                </MenuItem>
                                                            </Menu>
                                                        </Grid>
                                                    )}
                                                </Draggable>
                                            ))}
                                        {provided.placeholder}
                                    </Grid>
                                )}
                            </Droppable>
                        </DragDropContext>
                        :
                        <Alert severity="info">
                            <AlertTitle>Sin resultados</AlertTitle>
                            No hay ningún elemento guardado para en los webinars anteriores
                        </Alert>
                }
            </Container>

            <AddOldWebinar openDialog={openDialog} setOpenDialog={setOpenDialog} />
        </>
    )
}

export default OldWebinars